import styled from "styled-components"
export const Hero = styled.div`
  position: relative;
  height: 90vh;
  /* tablet y móvil: overlay transparente -> negro sobre el video para leer el título */
  @media (max-width: 1024px) {
    &::before {
      content: "";
      position: absolute;
      inset: 0;
      background: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0.15),
        rgba(0, 0, 0, 0.5)
      );
      pointer-events: none;
    }
  }
`
export const Banner = styled.div`
  z-index: 1;
  position: absolute;
  top: 0;
  width: 100%;
  right: 0;
  left: 0;
  bottom: 0;
`
export const BannerGrid = styled.div`
  display: grid;
  height: calc(100% - 1rem);
  padding: 1rem 0 0;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr auto ;
  h1,
  P {
    color: ${({ theme }) => theme.colors.gris};
    text-shadow: 2px 2px black
  }
  a {
    color: ${({ theme }) => theme.colors.amarillo};
    text-decoration: none;
    /* border: 1px solid ${({ theme }) => theme.colors.gris}; */
    background-color: ${({ theme }) => theme.colors.azul};
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    padding: 1rem 2rem;
    font-weight:bold;
    font-size: ${({ theme }) => theme.fontsize.large};
    transition: 0.3s;
    &:hover {
      background-color: ${({ theme }) => theme.colors.amarillo};
      color: ${({ theme }) => theme.colors.azul};
    }
  }
  h1 {
    text-align: center;
    font-size: ${({ theme }) => theme.fontsize.xlextralarge};
    align-self: center;
    margin: 1rem 0;
  }
  .info-limpo {
    text-align: center;
    align-self: flex-end;
  }
  .comillas {
    color: ${({ theme }) => theme.colors.amarillo};
  }
  @media (max-width: 920px) {
  }
  @media (max-width: 640px) {
  }
`
